module.exports = __webpack_public_path__ + "static/media/am_logo.c392ad2c.png";